import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "onClick"];
import React from 'react';
import { Box, Link } from '../';
import getConfig from '../../js/settings';
import { appendHtmlClass, getAnimationEasing, getAnimationDuration } from '../../js/util';
import './_index.scss';
var Backdrop = function Backdrop(_ref) {
  var className = _ref.className,
    onClick = _ref.onClick,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  className = appendHtmlClass(className, 'backdrop');
  if (typeof onClick === 'function') {
    className = appendHtmlClass(className, 'closeable');
  }
  var DRAWER_ANIMATION_DURATION = getConfig('DRAWER_ANIMATION_DURATION');
  var visible = {
    opacity: 1
  };
  var hidden = {
    opacity: 0
  };
  var variants = {
    visible: visible,
    hidden: hidden
  };
  var initial = 'hidden';
  var transition = {
    ease: getAnimationEasing('ease'),
    duration: getAnimationDuration(DRAWER_ANIMATION_DURATION)
  };
  return /*#__PURE__*/React.createElement(Link, Object.assign({
    className: className,
    onClick: onClick,
    type: "raw",
    isAnimated: true,
    variants: variants,
    transition: transition,
    initial: initial
  }, rest), /*#__PURE__*/React.createElement(Box, {
    bg: ['gray', -4, 5]
  }));
};
export default Backdrop;